import React from 'react'
import { RouterProvider } from './providers/RouterProvider'
import { ErrorBannerProvider } from 'shared/components/ErrorBanner/ErrorBannerProvider'

export default function App() {
	return (
		<ErrorBannerProvider>
			<RouterProvider />
		</ErrorBannerProvider>
	)
}
